// import state from './state'
// import * as getters from './getters'
// import * as mutations from './mutations'
import * as actions from './actions'
import config from '@/v2/config'

// initial state
const state = {
  car: {
    id: '',
    ts_id: '',
    popinfo_id: '',
    chassis_number: '',
    plate_number: '',
    model_code: null,
    manufacturer_id: null,
    weight: null,
    mileage: null,
    first_registration_on: '',
    expiry_on: '',
    motor_model: '',
    type_designation_number: '',
    classification_division_number: '',
    oil_exchanged: true,
    qr: '',
    application_category: config.APPLICATION_CATEGORY_APP,
    coupon: '',
    coupon_id: '',
    expiryGengo: 0,
    firstRegistrationGengo: 0
  }
}

// getters
const getters = {
  car: (state, getters) => {
    return state.car
  }
}

// mutations
const mutations = {
  SET_CAR (state, data) {
    state.car = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
